module.exports = __webpack_public_path__ + "static/ICONMESSANGES-07-d1a276794b10acc8b3c9fb4f94f7fcd9.png";